import { IOperation } from '@/models/IFunctionality';
import { IRecord, IRecords } from '@/models/IRecord';
import RightArrow from '@icons/arrowRightIcon.svg?react';
import { ModelDocumentation } from '../../ModelDocumentation';
import FunctionalityRecordDetail from '../records/FunctionalityRecordDetail';

export interface IFunctionalityOperationDetail {
  operation: IOperation;
  records: IRecords;
  'data-testid'?: string;
}

export default function FunctionalityOperationDetail({
  operation,
  records,
  'data-testid': dataTestId
}: IFunctionalityOperationDetail) {
  const renderInput = () => {
    if (!operation.input || !records) {
      return <div className="flex items-center justify-center">None</div>;
    }
    const operationKey = operation.input.$ref.split('/').pop();
    if (!operationKey)
      return <div className="flex items-center justify-center">None</div>;

    const record = records[operationKey] as IRecord;
    return (
      <div
        className="flex items-center justify-center"
        data-testid="operation-input-json"
      >
        <FunctionalityRecordDetail
          name={operationKey}
          record={record}
          records={records}
        />
      </div>
    );
  };

  const renderOutput = () => {
    if (!operation.output || !records) {
      return <div className="flex items-center justify-center">None</div>;
    }

    const referenceKey = operation.output.$ref.split('/').pop();
    if (!referenceKey)
      return <div className="flex items-center justify-center">None</div>;
    const record = records[referenceKey] as IRecord;
    return (
      <div
        className="flex items-center justify-center flex-col"
        data-testid="operation-output-json"
      >
        <FunctionalityRecordDetail
          name={referenceKey}
          record={record}
          records={records}
        />
      </div>
    );
  };

  return (
    <div data-testid={dataTestId}>
      {operation?.doc && <ModelDocumentation doc={operation.doc} />}
      <div className="grid grid-cols-[1fr,30px,1fr] gap-2">
        <div className="text-base font-bold text-center">Input</div>
        <div></div>
        <div className="text-base text-center font-bold">Output</div>
        {renderInput()}
        <div className="flex items-center">
          <RightArrow />
        </div>
        {renderOutput()}
      </div>
    </div>
  );
}
